import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';

export const testId = 'highDemandAlertId';
export const testIdJoinJourney = 'highDemandAlertJoinJourneyId';

export const HighDemandAlert = () => {
  const { showHighDemandWarning } = useFlags();
  const { activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];

  if (!showHighDemandWarning) {
    return null;
  }

  return (
    <NsAlert state="warning" heading="High demand" testId={testId}>
      {isMoveInJourney ? (
        <p>
          We&apos;re currently experiencing high demand for our tariffs right
          now so you may experience an issue getting a quote. If you are
          impacted, please come back soon and try again as we&apos;re working
          hard to resolve this.
        </p>
      ) : (
        <p data-testid={testIdJoinJourney}>
          We&apos;re currently experiencing high demand for our tariffs right
          now so you may experience an issue getting a quote. If you are
          impacted, please give us a call to get a quote on{' '}
          <NsAnchor href={`tel:03301000540`}>0330 100 0540</NsAnchor>. Our
          expert team is available Monday to Friday 8am-6pm.
        </p>
      )}
    </NsAlert>
  );
};
